import { render, staticRenderFns } from "./IntakeReferrals.vue?vue&type=template&id=2f9813d5&scoped=true&"
import script from "./IntakeReferrals.vue?vue&type=script&lang=js&"
export * from "./IntakeReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9813d5",
  null
  
)

export default component.exports